
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/longrangemovers/privacy-policy",
      function () {
        return require("private-next-pages/longrangemovers/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/longrangemovers/privacy-policy"])
      });
    }
  